/* eslint-disable import/no-default-export */
export default (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');



// WEBPACK FOOTER //
// ./app/common/lib/util/safe.ts